export default __webpack_public_path__ + "65d612f0aa91361f4dc1248e80f10f93.png";